import { Component, OnInit } from '@angular/core';
import { SESSION_STORAGE_KEYS } from '../../services/session-timeout.service';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.css']
})
export class LoginLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.addEventListener('storage', function (event) {
      if (event.key === SESSION_STORAGE_KEYS.LOGGED_IN) {
        if (localStorage.getItem(SESSION_STORAGE_KEYS.LOGGED_IN) === 'true') {
          window.location.reload();
        }
      }

      // Another tab completed logout — stay on login page with a clean state.
      if (event.key === SESSION_STORAGE_KEYS.SESSION_LOGOUT) {
        window.location.href = '/login';
      }
    }, false);
  }

}
